import
  Link
from 'next/link';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS
} from '@repo/brand';

interface ServiceItemProps {
  label: string
  href: string
}

export default function ServiceItem({
  label, href
}: ServiceItemProps) {

  return (
    <li>
      <Link href={href} className="flex items-center gap-3 group">
        <span
          className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${ BRAND_GRADIENT_DARK_GLASS }`}
          style={{
            background: BRAND_GRADIENT
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-2.5 h-2.5 fill-white">
            <path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" />
          </svg>
        </span>
        <span className="text-sm font-semibold text-[#0a1628] dark:text-white group-hover:text-[#c8861c] transition-colors">
          {label}
        </span>
      </Link>
    </li>
  );
}
